import { Box, Stack } from '@mui/material';
import { getTextInputBorderContainerSx } from 'components/Search/styles';
import { Fragment, memo } from 'react';
import {
  activeFiltersBoxSx,
  inputsRightContainerSx,
  viewSwitchContainerSx,
} from '../generic/SearchModalLayout';
import { SearchModalSortDropdownGeneric } from '../generic/SearchModalSortDropdown';
import { SearchModalTextInputGeneric } from '../generic/SearchModalTextInput';
import { SearchModalViewSelectGeneric } from '../generic/SearchModalViewSelect';
import { useSearchModalContext } from '../SearchModal';
import {
  SearchModalActiveFiltersBarEditorial,
  SearchModalPopoverFiltersEditorial,
} from './SearchModalFiltersEditorial';
import { SearchModalResultsCountGeneric } from '../generic/SearchModalResultsCount';

/**
 * --------------------------------------------------------
 * Editorial Inputs - Left Component
 * - View Switcher, Input Field, Advanced Btn & Popover
 * --------------------------------------------------------
 */

export const SearchModalInputsLeftEditorial = memo(() => {
  const {
    textBoxSizeRef,
    textBoxWidth,
    advPopoverAnchorEl,
    advPopoverOpen,
    handleCloseAdvPopover,
  } = useSearchModalContext();

  return (
    <Fragment>
      <Box
        data-testid="search-modal-view-switch-container-editorial"
        sx={viewSwitchContainerSx}
      >
        <SearchModalViewSelectGeneric />
      </Box>

      <Stack
        data-testid="search-modal-text-input-container-editorial"
        ref={textBoxSizeRef}
        sx={getTextInputBorderContainerSx}
      >
        <SearchModalTextInputGeneric />
      </Stack>

      {/* Mount Editorial Advanced Popover */}
      <SearchModalPopoverFiltersEditorial
        open={advPopoverOpen}
        setClosed={handleCloseAdvPopover}
        anchorEl={advPopoverAnchorEl}
        popoverSx={{ width: textBoxWidth + 5 }}
      />
    </Fragment>
  );
});
SearchModalInputsLeftEditorial.displayName = 'SearchModalInputsLeftEditorial';

/**
 * --------------------------------------------------------
 * Editorial Inputs - Right Component
 * - Results Count, Card Sort Dropdown
 * --------------------------------------------------------
 */
export const SearchModalInputsRightEditorial = memo(() => {
  const { view } = useSearchModalContext();
  const isCardView = view === 'card';

  return (
    <Box
      data-testid="search-modal-inputs-right-editorial"
      sx={inputsRightContainerSx}
    >
      <SearchModalResultsCountGeneric />
      {/* Sort Dropdown - Card View */}
      {isCardView && <SearchModalSortDropdownGeneric />}
    </Box>
  );
});
SearchModalInputsRightEditorial.displayName = 'SearchModalInputsRightEditorial';

/**
 * --------------------------------------------------------
 * Editorial Inputs - Bottom Component
 * - Active Filters Bar
 * --------------------------------------------------------
 */

export const SearchModalInputsBottomEditorial = memo(() => {
  return (
    <Box
      data-testid="search-modal-filters-bar-editorial"
      sx={activeFiltersBoxSx}
    >
      <SearchModalActiveFiltersBarEditorial />
    </Box>
  );
});
SearchModalInputsBottomEditorial.displayName = 'SearchModalInputsBottomEditorial';
